import { useSuspenseQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { selectProfileByIdQueryOptions } from "../api/selectProfile";
import useProfileAttributes from "./useProfileAttributes";

const useProfileProgress = (userId: string) => {
    const { data: profile } = useSuspenseQuery(selectProfileByIdQueryOptions(userId));
    const profileAttributes = useProfileAttributes();

    const { progress, incomplete } = useMemo(() => {
        const entries = Object.entries(profileAttributes);

        if (entries.length === 0) {
            return { progress: null, incomplete: !profile?.organisations?.length };
        }

        const numberIncomplete = entries.filter(([, attribute]) => attribute === true).length;
        const hasMissingFields = numberIncomplete > 0 || !profile?.organisations?.length;
        const calculatedProgress = Math.round(((entries.length - numberIncomplete) / entries.length) * 100);

        return { progress: calculatedProgress, incomplete: hasMissingFields };
    }, [profileAttributes, profile?.organisations?.length]);

    return { progress, incomplete, recalculateProfileProgress: () => undefined };
};

export default useProfileProgress;
